var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-crud',{attrs:{"crudName":"Gerenciar Dados","newText":"Gerenciar Dados","table":_vm.dataManagersTable,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableAdd":true,"enableEdit":true,"enableDelete":true,"enableView":true,"dataForm":_vm.dataForm,"customFilters":_vm.customFilters,"extra":_vm.extra}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }